import { FormattedMessage } from 'react-intl';
import { useBrand } from '@kiwicom/nitro/lib/services/brand/context';
import { Box, Heading, Text, Button, ButtonLink } from '@kiwicom/orbit-components';

type ReferFriendErrorContentProps = {
  title: string;
  description: string;
  locale: string;
  onInviteFriendsClick: () => void;
};

const ReferFriendErrorContent = ({
  title,
  description,
  locale,
  onInviteFriendsClick,
}: ReferFriendErrorContentProps) => {
  const { company_name: companyName } = useBrand();

  return (
    <>
      <Heading spaceAfter="medium" type="title2">
        {title}
      </Heading>
      <Text size="large" spaceAfter="large">
        {description}
      </Text>

      <Box
        display="flex"
        direction="column"
        align="center"
        justify="center"
        tablet={{ direction: 'row', justify: 'start' }}
        className="flex-1"
      >
        <Box className="w-full tb:w-auto mb-400 tb:mb-0 tb:mr-1200">
          <Button onClick={onInviteFriendsClick} fullWidth>
            <FormattedMessage
              id="account_v2.components.refer_friend.invite_friends_button"
              defaultMessage="Invite friends"
            />
          </Button>
        </Box>

        <ButtonLink href={`/${locale}`}>
          <Text type="primary">
            <FormattedMessage
              id="account_v2.component.explore_button"
              defaultMessage="Explore {companyName}"
              values={{ companyName }}
            />
          </Text>
        </ButtonLink>
      </Box>
    </>
  );
};

export default ReferFriendErrorContent;
